export default function TextInput({ value, onChange }) {
  return (
    <div className="flex flex-col gap-2">
      <textarea
        className="sb-input h-40 resize-none"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Text hier eingeben..."
      />
    </div>
  );
}
